import * as Sentry from '@sentry/react';
import React, { useCallback, useEffect, useLayoutEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowBackIos, ArrowForwardIos, Add, Delete, Close, Star } from '@mui/icons-material';

import { Alert } from '@mui/material';
import Loading from 'components/Loading';
import PageImagePicker from "components/AdminBooks/PageImagePicker";
import PageToolbar from "components/AdminBooks/pageToolbar";
import Pages from "components/AdminBooks/pages";
import { Snackbar } from '@mui/material';
import SpinLoader from 'components/Loader/SpinLoader';
import Tag from 'components/Tag';
import { get, cloneDeep, filter, find, findIndex, has, map, uniqBy } from "lodash";
import queryString from 'query-string';
import styled from 'styled-components';
import { Col, Row, Dropdown, message as MessageAlert } from 'antd';
import { handleAiContentStoreUpdate, handleListVocabularyNew } from 'store/vocabulary/thunks';
import { handleGetAllSlides } from 'store/slides/thunk';
import { handleListChapterArticle } from 'store/StoryAiCofig/thunks';
import { handleListGrammarContent, handleListVocabContent } from 'store/page_translations/thunks';
import { handleListVocabularyCogantes } from 'store/cogantes/thunks';
import { makeStyles } from 'utils/styles/mui';
import { mapBookByOrderOnlyCreateUser } from 'utils/lib/ebookHelper';
import { useBookOrder } from 'store/books/selectors';
import { usePageTranslations } from 'store/page_translations/selectors';
import { handleListChapterInteractions } from "store/interactions/thunks";
import COLOR from "utils/constants/color"

import { Button, IconButton, Modal, FormControlLabel, Switch, TextField, InputLabel, Select, FormControl, MenuItem, Typography, Tooltip, Chip } from '@mui/material'
import { MenuBook } from '@mui/icons-material'
import BookNavigation from 'components/AdminBooks/BookNavigation'
import NavigationInputs from 'components/AdminBooks/NavigationInputs'
import { convertToRoman, getNextNumberMask } from "utils/methods/math"
import { handleCreateBook, handleUpdateBook , handleUpdateBookByPage, handleDeleteBookPage, handleAddBookPageInMiddle } from "store/books/thunks"

import { DeleteModal } from "components/Dialog"
import { handleListActivities } from 'store/activities/thunks';
import { handleListQuizzes } from 'store/quizzes/thunks';
import { handleListLessonPlanByBook } from 'store/lesson_plan/thunks';
import { useClassBooks } from 'components/hooks/books/useClassBooks';
import { handleNonNativeEbookListHighlights } from 'store/ebookNonNativeImageHighLighter/thunks';

import { useAdminActivityLogger, getActionFromFieldsAndMessage } from 'components/hooks/useAdminActivityLogger';
import { v4 } from 'uuid';
import SentryWrap from 'components/Sentry';
import { handleListChapterActivities } from 'store/activities/thunks';
import { handleListChapterQuizzes } from 'store/quizzes/thunks';
import { redirectToHome } from 'utils/config/navigation';



const BLANK_PG = {
    pageId: null,
    resource: null,
    description: null,
    NumberMasked: null
}
/**
 * {
 * from:page_id,
 * to:page_id,
 * content:content
 * }
 */

const ButtonContainer = styled.button`
    background-color: transparent;
    border: none;
    color: ${COLOR.black600};
    cursor: pointer;
    height: 40px;
    left: ${p => `${p.left}px`};
    outline: none;
    position: absolute;
    right: ${p => `${p.right}px`};
    top: 10px;
    transition: all 300ms ease;
    width: 40px;
    z-index: 1;
    
`;

const Container = styled.div`
    align-items: stretch;
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    max-width: 1268px;
    padding: 64px 0px 0px;
    position: relative;
    width: 100%;
    margin-top:10px;

    @media (min-width: 997px) {
        flex-direction: row;
        padding: 0px 30px;
    }
`;

const ToolsContainer = styled.div`
    height: 100%;
    margin-top: 48px;
    width: 100%;

    @media (min-width: 997px) {
        margin-left: 48px;
        margin-top: 0px;
        width: 350px;
    }
`;

const Wrapper = styled.div`
    display: flex;
    position: relative;
    width: 100%;
    flex-direction: column;
`;
const CoverText = styled.div`
width: 100%;
display: flex;
justify-content: center;
align-items: center;
font-size: 12px;
font-weight: bold;
margin-top: -10px;
`;
const ModalContent = styled.div`
  left: 50%;
  width: 80vw;
  padding: 0px 24px;
  position: absolute;
  top: 50%;
  height:90%;
  transform: translate(-50%, -50%);
  background-color:#fff;
  padding:20px;
  overflow:scroll;
     @media only screen and (max-width: 600px) {
        width: 90%;
    }
`;
const ModalConfigArea = styled.div`
  margin-top:10px;
`;

const Note = styled.span`
    color: ${COLOR.black400};
    display: block;
    font-size: 10px;
    font-weight: 400;
    line-height: 20px;
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
    margin-left:5px;
    margin-top:5px;
`;
const VideoContainer = styled.div`
  flex: 1;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;


const Toolbar = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${'' /* padding: 16px; */}
  gap: 16px;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

const RightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

const Page = styled.div`
//   align-items: center;
//   color: ${COLOR.black100};
//   display: flex;
//   flex-direction: row;
//   font-size: 14px;
//   font-weight: 400;
  white-space: nowrap;
`;

const Input = styled.input`
  background-color: transparent;
  border: 1px dashed gray;
  border-radius: 3px;
  box-shadow: none;
  font-size: inherit;
  font-weight: 600;
  outline: none;
  padding: 0px 2px;
  transition: all 300ms ease;
  width: 80px;
`;

const useStyles = makeStyles((theme) => ({
    button: {
        margin: '2px',
    },
    rootDif: {
        width: '200px'
    },
    rootDifFull: {
        width: "100%"
    },
    sizeSmall: {
        width: '55px',
        height: '25px'
    },
    checkedSwitch: {
        transform: 'translateX(30px) !important'
    },
    label: {
        textTransform: 'uppercase',
    },
    formControl: {
        minWidth: 120
    },
    colorPrimary: {
        color: `${COLOR.green}!important`
    }
}));

function filterOrdersByOrderIds(oneArray, orderIds) {
    const filteredOrders = [];
    for (const orderItem of oneArray) {
        if (
            orderItem.order?.some((itemId) => orderIds === itemId)
        ) {
            filteredOrders.push(orderItem);
        }
    }

    return filteredOrders;
}

function Index({ currentUser, booksAllList, quizzes, activities, interactions, tips }) {
    const location = useLocation();
    const navigate = useNavigate();
    const classes = useStyles();
    const dispatch = useDispatch()
    const bookOrder = useBookOrder()
    const search = queryString.parse(location.search);
    const { logBookActivity } = useAdminActivityLogger();
    const bookTips = filter(tips, t => t.bookId == search.bookId)
    const bookIntractions = filter(interactions, t => t.chapter == search.bookId || t.bookId == search.bookId)
    const [description, setDescription] = useState('')
    const [pages, setPages] = useState([{
        pageId: 1,
        resource: null,
        description: null,
        NumberMasked: convertToRoman(1),
        new: true
    }])
    const [pageid, setpageid] = useState();
    const [maskId, setMaskId] = useState();
    const [editBook, setEditBook] = useState(null)
    const [pagesTeacher, setPagesTeacher] = useState([])
    const [pacingTeacher, setPacingTeacher] = useState([])
    const [syllabusTeacher, setSyllabusTeacher] = useState([])
    const [pagesPDF, setPagesPDF] = useState([])
    const [teacherEdition, setTeacherEdition] = useState([])
    const [engage, setEngage] = useState([])
    const [subTopics, setSubTopics] = useState([])
    const [lessonPlan, setLessonPlan] = useState([])
    const [superLesson, setSuperLesson] = useState([])
    const [differentiationLesson, setDifferentiationLesson] = useState([])
    const [sentenceStarter,setSentenceStareter] = useState([]);
    const [assignmentPlan, setAssignmentPlan] = useState([])
    const [game_ai_content, set_game_ai_content] = useState([])
    const [workbook_plan, setWorkbook_plan] = useState([])
    const [assignment_book_link_plan, setAssignment_book_link_plan] = useState([])
    const [main_book, setMainBook] = useState([])
    const [rubricsPlan, setRubricsPlan] = useState([])
    const [demoPages, setDemoPages] = useState({})
    const [hyperlinks, setHyperlinks] = useState([])
    const [count, setCount] = useState(false)
    const [printable, setPrintable] = useState(false)
    const [isNotAssignable, setIsNotAssignable] = useState(false)
    const [markAsMainBook, setMarkAsMainBook] = useState(false);
    const [onlyTeacher, setOnlyTeacher] = useState(false)
    const [teacherEditionBook, setTeacherEditionBook] = useState('')
    const [alertSakeBar, setAlertSakeBar] = useState({ open: false, message: '', severity: "success" })
    const [cover, setCover] = useState('')
    const [level, setlevel] = useState(null)
    const [language, setLanguage] = useState(null)
    const [type, setType] = useState(null)
    const [storyId, setStoryId] = useState(null)
    const [activeIndex, setActiveindex] = useState(0)
    const [saveModal, setSaveModal] = useState(false)
    const [bookActivities, setBookActivties] = useState([])
    const [bookQuizzes, setBookQuizzes] = useState([])
    const backBtnRef = useRef(null)
    const forwardBtnRef = useRef(null)
    const urlBookPageSyncKeyRef = useRef('')
    const [bookErrors, setErrors] = useState([])
    const [loading, setloading] = useState(false)
    const pg = pages[activeIndex] ? pages[activeIndex] : {}
    const [deletePageModal, setDeletePageModal] = useState(false)
    const [addPageModal, setAddPageModal] = useState(false)
    const [addLoader, setAddLoader] = useState(false)
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [updateLoader, setUpdateLoader] = useState(false);
    const [bookIdVoc, setBookIdVoc] = useState();
    const [dataloader,setdataloader] = useState(false);
    const [loaderImg, setLoaderImg] = useState(false);
    const [unitExam,setUnitExam] = useState(false);
    const [markAsAssessment, setMarkAsAssessment] = useState(false);
    const [pageToDelete, setPageToDelete] = useState(null);
    const orderedBook = mapBookByOrderOnlyCreateUser(booksAllList, filterOrdersByOrderIds(bookOrder, search.bookId))[0]?.books;    
    const AsessmentBookOrder = find(orderedBook, (bookOrder) => bookOrder?.is_assessment_book)
    const markAsMainBookOrder = find(orderedBook, (bookOrder) => bookOrder?.markAsMainBook)
    
    const isAssessment = AsessmentBookOrder?.id === search.bookId;    
    const isMarkAsMainBook = markAsMainBookOrder?.id === search.bookId;
    const [selectedValue, setSelectedValue] = useState("");
    const [disableNative, setDisableNative] = useState("");
    const main_book_data = find(booksAllList, bk => bk.id == search.bookId);
    const { handleFetchPageTranslations } = usePageTranslations()
    const [navigationOpen, setNavigationOpen] = useState(false);
    const { fetchActivitiesForBooks, fetchQuizzesForBooks } = useClassBooks();

    const onAdminAssignmentRefetch = useCallback(
        async (otherChapterId) => {
            if (!search.bookId) return;
            const ids = new Set([String(search.bookId)]);
            if (otherChapterId != null && String(otherChapterId) !== String(search.bookId)) {
                ids.add(String(otherChapterId));
            }
            await Promise.all(
                [...ids].flatMap((id) => [
                    dispatch(handleListChapterActivities(id)),
                    dispatch(handleListChapterQuizzes(id)),
                ])
            );
        },
        [search.bookId, dispatch]
    );

    const handleChange = (event) => {
        const selectedOption = event.target.value;
        setSelectedValue(selectedOption);
    };
    const vocabLoader = async (isLoader = false) =>{
        setdataloader(true);
        await Promise.allSettled([
            dispatch(handleGetAllSlides(search.bookId)),
            dispatch(handleListGrammarContent(search.bookId)),
            dispatch(handleListVocabContent(search.bookId)),
            handleFetchPageTranslations(search.bookId),
            dispatch(handleListChapterInteractions(search.bookId)),
            dispatch(handleListVocabularyNew({ user_id: get(currentUser, "id", ''),created_by:"owe_admin", book_id: search.bookId })),
            dispatch(handleListVocabularyCogantes({ user_id: get(currentUser, "id", ''),created_by:"owe_admin", book_id: search.bookId })),
            dispatch(handleListChapterArticle({chapter : search.bookId })),
            dispatch(handleListLessonPlanByBook(search.bookId)),
            dispatch(handleListChapterQuizzes(search.bookId)),
            dispatch(handleListChapterActivities(search.bookId))
        ])
        setdataloader(isLoader);
    }
    useEffect(()=>{
        vocabLoader(false)
    },[currentUser])

    useEffect(() => {
      setpageid(pg.pageId);
    }, [pg.pageId]);

    useEffect(() => {
        setMaskId(pg.NumberMasked || pg.pageId);
    }, [pg.NumberMasked, pg.pageId])

    useLayoutEffect(() => {
        const bid = String(search.bookId ?? '');
        const sp =
            search.pageId != null && search.pageId !== ''
                ? String(search.pageId)
                : '';
        if (!sp) {
            return;
        }
        const nextKey = `${bid}:${sp}`;
        if (nextKey === urlBookPageSyncKeyRef.current) {
            return;
        }
        const ind = findIndex(pages, (k) => String(k.pageId) === sp);
        if (ind < 0) {
            return;
        }
        urlBookPageSyncKeyRef.current = nextKey;
        if (ind !== activeIndex) {
            setActiveindex(ind);
        }
    }, [search.bookId, search.pageId, pages, activeIndex]);

    useEffect(() => {
        const bookIdForUrl = editBook?.id ?? search.bookId;
        if (!bookIdForUrl) {
            return;
        }
        if (!Array.isArray(pages) || pages.length === 0) {
            return;
        }
        if (pages[0]?.new) {
            return;
        }
        const currentPg = pages[activeIndex];
        if (!currentPg) {
            return;
        }
        const pid = currentPg.pageId;
        const params = { bookId: String(bookIdForUrl) };
        if (pid != null && pid !== '') {
            params.pageId = String(pid);
        }
        const parsed = queryString.parse(location.search);
        const qVal = (v) => {
            if (v == null) {
                return '';
            }
            return String(Array.isArray(v) ? v[0] : v);
        };
        const sameBook = qVal(parsed.bookId) === String(params.bookId);
        const samePage =
            qVal(parsed.pageId) === (params.pageId != null ? String(params.pageId) : '');
        if (sameBook && samePage) {
            return;
        }
        const qs = queryString.stringify(params);
        navigate({ pathname: location.pathname, search: qs ? `?${qs}` : '' }, { replace: true });
    }, [editBook?.id, search.bookId, activeIndex, pages, location.pathname, navigate]);

    useEffect(() => {
        const preloadImages = () => {
            const startIndex = Math.max(0, activeIndex - 5);
            const endIndex = Math.min(pages.length - 1, activeIndex + 5);
            
            for (let i = startIndex; i <= endIndex; i++) {
                if (i !== activeIndex && pages[i]?.resource) {
                    const img = new Image();
                    img.src = pages[i].resource;
                }
            }
        };

        preloadImages();
    }, [activeIndex, pages]);

    useEffect(() => {
        if (get(currentUser, "role") !== "admin" && get(currentUser, "role") !== "owe_admin") {
            navigate(redirectToHome(currentUser) || '-1');
        }
    }, [currentUser])
    useEffect(() => {
        if (search.bookId) {
            setBookActivties(filter(activities, ac => ac.bookId == search.bookId || ac.chapter == search.bookId))
        }
    }, [activities])
    useEffect(() => {
        if (search.bookId) {
            setBookQuizzes(filter(quizzes, ac => ac.bookId == search.bookId || ac.chapter == search.bookId))
        }
    }, [quizzes])
    const setBookData = (book) => {
        setEditBook(book)
        setPages(book.pages)
        setDescription(book.description)
        setPagesTeacher(book.pagesTeacher)
        setPacingTeacher(book?.pacingTeacher)
        setSyllabusTeacher(book?.syllabusTeacher)
        setPagesPDF(book?.pagesPDF || [])
        setTeacherEdition(book.teacherEdition)
        setSubTopics(book.subTopics)
        setLessonPlan(book.lessonPlan)
        setSuperLesson(book.superLesson)
        setDifferentiationLesson(book.differentiationLesson)
        setSentenceStareter(book.sentence_starter_data);
        setAssignmentPlan(book.assignmentPlan)
        set_game_ai_content(book.ai_content)
        setUnitExam(book.unit_exam)
        setMarkAsAssessment(book.is_assessment_book)
        setWorkbook_plan(book.workbook_plan)
        setAssignment_book_link_plan(book.assignment_book_link_plan)
        setMainBook(book.main_book)
        setRubricsPlan(book.rubrics)
        setDemoPages(book.demoPages)
        setHyperlinks(book.hyperlinks)
        setCount(book.count)
        setPrintable(book.printable)
        setIsNotAssignable(book.isNotAssignable)
        setMarkAsMainBook(book.markAsMainBook)
        setOnlyTeacher(book.onlyTeacher)
        setTeacherEditionBook(book.teacherEditionBook)
        setCover(book.img)
        setlevel(book.level)
        setLanguage(book.language)
        setType(book.type)
        setStoryId(book.stoyId)
        setSelectedValue(book?.book_type || "")
        setDisableNative(book.book_type)
    }
    useEffect(() => {
        const book = find(booksAllList, bk => bk.id == search.bookId)
        const pageId = search.pageId;
        const booksForVoc = find(booksAllList, bk => bk.id)
        setBookIdVoc(booksForVoc);
        if (book && pages[0].new) {
            setBookData(book)
            setEditBook(book)
            setPages(book.pages)
            setDescription(book.description)
            setPagesTeacher(book.pagesTeacher)
            setPacingTeacher(book?.pacingTeacher)
            setSyllabusTeacher(book?.syllabusTeacher)
            setPagesPDF(book?.pagesPDF || [])
            setTeacherEdition(book.teacherEdition)
            setEngage(book.engage)
            setSubTopics(book.subTopics)
            setLessonPlan(book.lessonPlan)
            setSuperLesson(book.superLesson)
            setDifferentiationLesson(book.differentiationLesson)
            setSentenceStareter(book.sentence_starter_data);
            setAssignmentPlan(book.assignmentPlan)
            set_game_ai_content(book.ai_content)
            setUnitExam(book.unit_exam)
            setMarkAsAssessment(book.is_assessment_book)
            setWorkbook_plan(book.workbook_plan)
            setAssignment_book_link_plan(book.assignment_book_link_plan)
            setMainBook(book.main_book)
            setRubricsPlan(book.rubrics)
            setDemoPages(book.demoPages)
            setHyperlinks(book.hyperlinks)
            setCount(book.count)
            setPrintable(book.printable)
            setIsNotAssignable(book.isNotAssignable)
            setMarkAsMainBook(book.markAsMainBook)
            setOnlyTeacher(book.onlyTeacher)
            setTeacherEditionBook(book.teacherEditionBook)
            setCover(book.img)
            setlevel(book.level)
            setLanguage(book.language)
            setType(book.type)
            setStoryId(book.stoyId)
            setSelectedValue(book?.book_type || "")
            setDisableNative(book.book_type)
            if (pageId != null && pageId !== '') {
                const ind = findIndex(book.pages, (k) => String(k.pageId) === String(pageId));
                if (ind >= 0) {
                    setActiveindex(ind);
                }
            }
        } else {
            if (book && Array.isArray(book.pages) && book.pages.length > 0) {
                setPages(book.pages)
            }
        }
    }, [booksAllList])
    const onPageImageChange = (item) => {
        const pageId = item.pageId;
        // const index = findIndex(pages, k => k.pageId == pageId)
        // const pagesfile = pages[index]
        // const url = item.url
        // const _pgs = cloneDeep(pages)
   
        updateBookDataByPageWithKey(pageId, { resource: item.url }, 'pages', 'Cover image updated!', "success", "ai_image")
        if (editBook?.id) {
            logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                pageId: pageId,
                action: 'page_image_update',
                url: item.url
            });
        }
        // const _pgs = cloneDeep(pages)
        // if (pagesfile) {
        //     if (url) {
        //         pagesfile.resource = url;
        //         _pgs[index] = pagesfile
        //         setPages(_pgs)
        //     }
        // } else {
        //     if (url) {
        //         _pgs.push({
        //             pageId: pageId,
        //             resource: url,
        //             NumberMasked: getNextNumberMask(pageId),
        //             description: ''
        //         })
        //         setPages(_pgs)
        //     }
        // }
        // updateBookData({ pages: _pgs }, `Page updated!`, "success")
    }
    const onChangeOrUpdateDescription = (item) => {
        const pageId = item.pageId;
        // const index = findIndex(pages, k => k.pageId == pageId)
        // const pagesfile = pages[index]
        // const _pgs = cloneDeep(pages)
        updateBookDataByPageWithKey(pageId, { description: item.description, tags: item.tags }, 'pages', 'Description and tags updated!', "success")
        if (editBook?.id) {
            logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                pageId: pageId,
                action: 'page_description_tags_update',
                description: item.description,
                tags: item.tags
            });
        }
        // if (pagesfile) {
        //     pagesfile.description = item.description;
        //     pagesfile.tags = item.tags;
        //     _pgs[index] = pagesfile
        //     setPages(_pgs)
        // }
        // updateBookData({ pages: _pgs }, `Description and tags updated!`, "success")
    }
    const onChangePagePrintableOption = (printable, pageId) => {
        const index = findIndex(pages, k => k.pageId == pageId)
        const pagesfile = pages[index]
        const _pgs = cloneDeep(pages)
        if (pagesfile) {
            pagesfile.printable = printable;
            _pgs[index] = pagesfile
            setPages(_pgs)
        }
        updateBookDataByPageWithKey(pageId, { printable: printable }, 'pages', `${printable ? 'Print option enabled for this page!' : 'Print option disabled for this page!'}`, "success")
        if (editBook?.id) {
            logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                pageId: pageId,
                action: 'page_printable_update',
                printable: printable
            });
        }
    }
    const onMaskChanged = (v) => {
        const pagesfile = pages[activeIndex]
        const _pgs = cloneDeep(pages)
        if (pagesfile) {
            const oldMask = pagesfile.NumberMasked;
            pagesfile.NumberMasked = v;
            _pgs[activeIndex] = pagesfile
            setPages(_pgs)
            updateBookDataByPageWithKey(pagesfile.pageId, { NumberMasked: v }, 'pages', 'Number mask updated!', "success")
            if (editBook?.id) {
                logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                    pageId: pagesfile.pageId,
                    action: 'number_mask_update',
                    oldMask: oldMask,
                    newMask: v
                });
            }
        }
    }
    const onBulkMaskGenerate = (updates) => {
        if (!updates?.length) return;
        const _pgs = cloneDeep(pages);
        updates.forEach(({ pageId, NumberMasked }) => {
            const idx = findIndex(_pgs, (p) => p.pageId == pageId);
            if (idx >= 0) {
                _pgs[idx].NumberMasked = NumberMasked;
            }
        });
        setPages(_pgs);
        updateBookData({ pages: _pgs }, 'Page masks generated!', 'success');
    }
    const onChangeDescription = (v) => {
        // const pagesfile = pages[activeIndex]
        // const _pgs = cloneDeep(pages)
        // if (pagesfile) {
        //     pagesfile.description = v;
        //     _pgs[activeIndex] = pagesfile
        //     setPages(_pgs)
        // }
    }
    function onForward() {
        setActiveindex(p=>p+1)
    }
    function onBackward() {
        setActiveindex(p=>p-1)
    }
    function checkKey(e) {
        if (e && e.repeat) {
            e.preventDefault();
            return;
        }
        let activeElement = document.activeElement;
        let disableArrow = false;
        const inputType = ['text','search','email','number','password']
        if((activeElement.tagName === 'INPUT'&&inputType.includes(activeElement.type)) || activeElement.tagName === 'TEXTAREA' || activeElement.classList?.contains('sun-editor-editable')){
            disableArrow = true;
        }
        const isDrawerOpen = document.getElementsByClassName("ant-drawer-open").length > 0;
        let isModalOpen = document.getElementsByClassName("ant-modal-mask").length > 0;
        let isCustomModal = document.getElementsByClassName("custom-modal").length > 0;
        const hasModal = document.querySelectorAll('[role="presentation"]').length > 0;
        if (isDrawerOpen || hasModal || disableArrow || isModalOpen || isCustomModal) return;
        e = e || window.event;
        if (e.keyCode == '37') {
            if (backBtnRef.current && !backBtnRef.current.disabled) {
                onBackward();
            }
        }
        else if (e.keyCode == '39') {
            if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
                onForward();
            }
        }
    }
    useEffect(() => {
        document.addEventListener('keydown', checkKey);
        return () => {
            document.removeEventListener('keydown', checkKey);
        }
    }, [backBtnRef,forwardBtnRef])
    const getIdInSeq = (_pgs) => {
        let id = 1;
        while (find(_pgs, p => p.pageId == id)) {
            id++;
        }
        return id;
    }

    const getActiveUnitInfo = () => {
        const currentPageId = pg?.pageId;
        if (!currentPageId || !subTopics || subTopics.length === 0) {
            return null;
        }

        for (let i = 0; i < subTopics.length; i++) {
            const unit = subTopics[i];
            const isInUnitRange = currentPageId >= parseInt(unit.startPage) && currentPageId <= parseInt(unit.finishPage);
            
            if (isInUnitRange) {
                let activeSubunit = null;
                if (Array.isArray(unit.subUnits) && unit.subUnits.length > 0) {
                    for (const subUnit of unit.subUnits) {
                        if (currentPageId >= parseInt(subUnit.start) && currentPageId <= parseInt(subUnit.finish)) {
                            activeSubunit = subUnit;
                            break;
                        }
                    }
                }
                
                return {
                    unit: unit.shortName || `Section ${i + 1}`,
                    subunit: activeSubunit ? (activeSubunit.label || 'Subunit') : null
                };
            }
        }
        return null;
    }
    const addPage = (index) => {
        if (!pages[pages.length - 1]?.resource) {
            setAlertSakeBar({
                open: true,
                message: "Please insert images befor adding new pages",
                severity: "error"
            })
            return;
        }
        let newPageId = 1;
        const _pgs = []
        map(pages, (p, i) => {
            if (!isNaN(p.pageId)) {
                newPageId = p.pageId
                p.pageId = parseInt(p.pageId, 10)
            } else {
                const getId = getIdInSeq(_pgs)
                if (!find(_pgs, k => k.pageId == newPageId + 1)) {
                    newPageId++
                    p.pageId = newPageId;
                } else {
                    newPageId = getId
                    p.pageId = getId;
                }
            }
            _pgs.push(p);
        })
        const _pg = cloneDeep(BLANK_PG);
        const lastPages = _pgs[_pgs.length - 1]
        const secondlastPages = _pgs[_pgs.length - 2]
        const lastPageId = isNaN(lastPages.pageId) ? newPageId : lastPages.pageId;
        _pg.pageId = parseInt(lastPageId) + 1
        _pg.NumberMasked = getNextNumberMask(lastPages.NumberMasked, get(secondlastPages, "NumberMasked"))
        if (index >= 0) {
            _pgs.splice(index, 0, _pg)
        } else {
            _pgs.push(_pg)
        }
        setPages(_pgs)
        updateBookDataByPageWithKey( _pg.pageId ,_pg,"add_pages",'Page added!')
        if (editBook?.id) {
            logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                action: 'page_added',
                pageId: _pg.pageId,
                totalPages: _pgs.length
            });
        }
        // updateBookData({pages:_pgs},"Pages added!","success")
        const last = _pgs.length - 1
        setActiveindex(last)
    }
    const handleListContent = async () => {
        await Promise.allSettled([
            vocabLoader(true),
            fetchActivitiesForBooks([search.bookId]),
            fetchQuizzesForBooks([search.bookId]),
            dispatch(handleNonNativeEbookListHighlights(search.bookId))
        ]).finally(() => {
            setdataloader(false)
        })
    }
    const onRemove = async () => {
        setDeleteLoader(true)
        try {
            const indexToDelete = pageToDelete !== null ? pageToDelete : activeIndex;
            const pageToDeleteData = pages[indexToDelete];
            
            if (!pageToDeleteData || !pageToDeleteData.pageId) {
                throw new Error('Invalid page data');
            }
            const deleteResponse = await dispatch(handleDeleteBookPage(search.bookId, pageToDeleteData.pageId));
            if (deleteResponse && deleteResponse.success) {   
                await handleListContent()  
                if(deleteResponse.book_info&&deleteResponse.book_info.pages){
                    const newPages = deleteResponse.book_info.pages
                    setBookData(deleteResponse.book_info);
                    setPages(newPages);
                    const currentPageId = pageToDeleteData.pageId
                    const currentPageIndex  = findIndex(newPages, p => p.pageId == currentPageId)
                    const nextIndexById = currentPageIndex-1;
                    // Set active index to one page back if it exists
                    const targetIndex = Math.max(0, Math.min(nextIndexById, newPages.length - 1));
                    setActiveindex(targetIndex);
                } else {
                    // Fallback if pages not returned
                    const targetIndex = Math.max(0, indexToDelete - 1);
                    setActiveindex(targetIndex);
                }
                setAlertSakeBar({
                    open: true,
                    message: "Page removed successfully!",
                    severity: "success"
                });
            } else {
                throw new Error('Failed to delete page');
            }
        } catch (error) {
            console.error('Error deleting page:', error);
            setAlertSakeBar({
                open: true,
                message: "Error removing page. Please try again.",
                severity: "error"
            });
        } finally {
            setDeletePageModal(false);
            setDeleteLoader(false);
            setPageToDelete(null);
        }
    }
    const handleAddPageClick = (selectedInsertionType = inserationType) => {
        setInserationType(selectedInsertionType);
        // Validate that all pages have images uploaded before showing dialog
        const firstMissingIndex = findIndex(pages, (p) => !p || !p.resource);
        if (firstMissingIndex >= 0) {
            const missingPid = pages[firstMissingIndex]?.pageId || firstMissingIndex + 1;
            setAlertSakeBar({
                open: true,
                message: `Please upload image for page ${missingPid} before adding a new page.`,
                severity: "error"
            });
            return;
        }
        setAddPageModal(true);
    }

    const [inserationType,setInserationType] = useState('after');
    const addPageMenuProps = {
        items: [
            { key: 'after', label: 'After' },
            { key: 'before', label: 'Before' }
        ],
        onClick: ({ key }) => handleAddPageClick(key)
    };
    const onAddPageAtCurrent = async () => {
        setAddLoader(true)
        try {
            const indexToAdd = activeIndex;
            const currentPageData = pages[indexToAdd];
            if (!currentPageData || !currentPageData.pageId) {
                throw new Error('Invalid page data');
            }
            const addResponse = await dispatch(handleAddBookPageInMiddle(search.bookId, currentPageData.pageId,inserationType));
            if (addResponse && addResponse.success) {
                if(addResponse.book_info&&addResponse.book_info.pages){
                    const newPages = addResponse.book_info.pages;
                    setBookData(addResponse.book_info);
                    const currentPageId = currentPageData.pageId;
                    const currentPageIndex  = findIndex(newPages, p => p.pageId == currentPageId)
                    const nextIndexById = inserationType === "before" ? currentPageIndex - 1 : currentPageIndex + 1;
                    const fallbackIndex = inserationType === "before"
                        ? Math.max(activeIndex - 1, 0)
                        : Math.min(activeIndex + 1, newPages.length - 1);
                    const targetIndex = nextIndexById >= 0 ? nextIndexById : fallbackIndex;
                    setActiveindex(targetIndex);
                } else {
                    const fallbackIndex = inserationType === "before"
                        ? Math.max(activeIndex - 1, 0)
                        : Math.min(activeIndex + 1, pages.length);
                    setActiveindex(fallbackIndex);
                }
                await handleListContent()
                setAlertSakeBar({
                    open: true,
                    message: "Page added successfully!",
                    severity: "success"
                });
                setAddPageModal(false)
            } else {
                throw new Error('Failed to add page');
            }
        } catch (error) {
            console.error('Error adding page:', error);
            setAlertSakeBar({
                open: true,
                message: "Error adding page. Please try again.",
                severity: "error"
            });
        } finally {
            setAddLoader(false)
        }
    }
    const onChangeHyPerLink = (data) => {
        const _pageHyperLinkIndex = findIndex(hyperlinks, k => k.page == data.page)
        let _hyperLink = hyperlinks ? cloneDeep(hyperlinks) : []
        if (_pageHyperLinkIndex >= 0) {
            _hyperLink[_pageHyperLinkIndex] = data
        } else {
            _hyperLink.push(data)
        }
        _hyperLink = _hyperLink.filter(k => k.links.length > 0)
        setHyperlinks(_hyperLink)
        updateBookData({ hyperlinks: _hyperLink }, "Hyperlink updated", "success")
    }

    const onChangeAnswerPage = (item) => {
        const url = item.url
        const pgTg = find(pagesTeacher, k => k.pageId == item.pageId && (k?.sequence === item?.sequence || !k?.sequence))
        const _pagesTeacher = pagesTeacher ? cloneDeep(pagesTeacher) : []

        if (pgTg) {
            pgTg.resource = url;
            _pagesTeacher[findIndex(pagesTeacher, k => k.pageId == item.pageId && k.sequence == item.sequence)] = pgTg
        } else {
            _pagesTeacher.push({
                pageId: item.pageId,
                resource: url,
                description: '',
                sequence: item.sequence
            })
        }
        setPagesTeacher(_pagesTeacher)
        updateBookData({ pagesTeacher: _pagesTeacher }, `Answer page updated!`, "success")
    }

    const onChangePacing = (item) => {
        const url = item.url
        const pgTg = find(pacingTeacher, k => k.pageId == item.pageId && (k?.sequence === item?.sequence || !k?.sequence))
        const _pagesTeacher = pacingTeacher ? cloneDeep(pacingTeacher) : []

        if (pgTg) {
            pgTg.resource = url;
            _pagesTeacher[findIndex(pacingTeacher, k => k.pageId == item.pageId && k.sequence == item.sequence)] = pgTg
        } else {
            _pagesTeacher.push({
                pageId: item.pageId,
                resource: url,
                description: '',
                sequence: item.sequence
            })
        }
        setPacingTeacher(_pagesTeacher)
        updateBookData({ pacingTeacher: _pagesTeacher }, `Answer page updated!`, "success")
    }
    const onChangeSyllabus = (item) => {
        const url = item.url
        const pgTg = find(syllabusTeacher, k => k.pageId == item.pageId && (k?.sequence === item?.sequence || !k?.sequence))
        const _pagesTeacher = syllabusTeacher ? cloneDeep(syllabusTeacher) : []

        if (pgTg) {
            pgTg.resource = url;
            _pagesTeacher[findIndex(syllabusTeacher, k => k.pageId == item.pageId && k.sequence == item.sequence)] = pgTg
        } else {
            _pagesTeacher.push({
                pageId: item.pageId,
                resource: url,
                description: '',
                sequence: item.sequence
            })
        }
        setSyllabusTeacher(_pagesTeacher)
        updateBookData({ syllabusTeacher: _pagesTeacher }, `Answer page updated!`, "success")
    }

    const onChangeAnswerDesc = (txt) => {
        const pgTg = find(pagesTeacher, k => k.pageId == pg.pageId)
        const _pagesTeacher = pagesTeacher ? cloneDeep(pagesTeacher) : []
        if (pgTg) {
            pgTg.description = txt;
            _pagesTeacher[findIndex(pagesTeacher, k => k.pageId == pg.pageId)] = pgTg
        } else {
            _pagesTeacher.push({
                pageId: pg.pageId,
                resource: '',
            })
        }
        setPagesTeacher(_pagesTeacher)
    }
    const onChangePacingAnswerDesc = (txt) => {
        const pgTg = find(pacingTeacher, k => k.pageId == pg.pageId)
        const _pagesTeacher = pacingTeacher ? cloneDeep(pacingTeacher) : []
        if (pgTg) {
            pgTg.description = txt;
            _pagesTeacher[findIndex(pacingTeacher, k => k.pageId == pg.pageId)] = pgTg
        } else {
            _pagesTeacher.push({
                pageId: pg.pageId,
                resource: '',
                description: txt
            })
        }
        setPacingTeacher(_pagesTeacher)
    }
    const onChangeSyllabusAnswerDesc = (txt) => {
        const pgTg = find(syllabusTeacher, k => k.pageId == pg.pageId)
        const _pagesTeacher = syllabusTeacher ? cloneDeep(syllabusTeacher) : []
        if (pgTg) {
            pgTg.description = txt;
            _pagesTeacher[findIndex(syllabusTeacher, k => k.pageId == pg.pageId)] = pgTg
        } else {
            _pagesTeacher.push({
                pageId: pg.pageId,
                resource: '',
                description: txt
            })
        }
        setSyllabusTeacher(_pagesTeacher)
    }
    const onRemoveAnsPage = (data, index) => {
        const deletedPage = data[index];
        const pgTgIndex = findIndex(pagesTeacher, k => k.pageId === deletedPage.pageId && k.sequence === deletedPage.sequence);
        const _pagesTeacher = cloneDeep(pagesTeacher);

        if (pgTgIndex >= 0) {
            _pagesTeacher.splice(pgTgIndex, 1);
        }

        let sequenceCounter = 1;
        _pagesTeacher.forEach((page) => {
            if (page.pageId === deletedPage.pageId) {
                page.sequence = sequenceCounter;
                sequenceCounter++;
            }
        });
        setPagesTeacher(_pagesTeacher)
        updateBookData({ pagesTeacher: _pagesTeacher }, `Answer page removed!`, "error")
    }
    const onRemovePacingAnsPage = (data, index) => {
        const deletedPage = data[index];
        const pgTgIndex = findIndex(pacingTeacher, k => k.pageId === deletedPage.pageId && k.sequence === deletedPage.sequence);
        const _pagesTeacher = cloneDeep(pacingTeacher);

        if (pgTgIndex >= 0) {
            _pagesTeacher.splice(pgTgIndex, 1);
        }

        let sequenceCounter = 1;
        _pagesTeacher.forEach((page) => {
            if (page.pageId === deletedPage.pageId) {
                page.sequence = sequenceCounter;
                sequenceCounter++;
            }
        });
        setPacingTeacher(_pagesTeacher)
        updateBookData({ pacingTeacher: _pagesTeacher }, `Answer page removed!`, "error")
    }

    const onRemoveSyllabusAnsPage = (data, index) => {
        const deletedPage = data[index];
        const pgTgIndex = findIndex(syllabusTeacher, k => k.pageId === deletedPage.pageId && k.sequence === deletedPage.sequence);
        const _pagesTeacher = cloneDeep(syllabusTeacher);

        if (pgTgIndex >= 0) {
            _pagesTeacher.splice(pgTgIndex, 1);
        }

        let sequenceCounter = 1;
        _pagesTeacher.forEach((page) => {
            if (page.pageId === deletedPage.pageId) {
                page.sequence = sequenceCounter;
                sequenceCounter++;
            }
        });
        setSyllabusTeacher(_pagesTeacher)
        updateBookData({ syllabusTeacher: _pagesTeacher }, `Answer page removed!`, "error")
    }

    const onChangePDF = (item) => {
        const url = item.url
        const pgPDF = find(pagesPDF, k => k.pageId == item.pageId)
        const _pagesPDF = pagesPDF ? cloneDeep(pagesPDF) : []

        if (pgPDF) {
            pgPDF.resource = url;
            pgPDF.fileName = item.fileName;
            _pagesPDF[findIndex(pagesPDF, k => k.pageId == item.pageId)] = pgPDF
        } else {
            _pagesPDF.push({
                pageId: item.pageId,
                resource: url,
                fileName: item.fileName
            })
        }
        setPagesPDF(_pagesPDF)
        updateBookData({ pagesPDF: _pagesPDF }, `PDF uploaded successfully!`, "success")
    }

    const onRemovePDF = (data) => {
        const pgPDFIndex = findIndex(pagesPDF, k => k.pageId === data.pageId);
        const _pagesPDF = cloneDeep(pagesPDF);

        if (pgPDFIndex >= 0) {
            _pagesPDF.splice(pgPDFIndex, 1);
        }

        setPagesPDF(_pagesPDF)
        updateBookData({ pagesPDF: _pagesPDF }, `PDF removed!`, "error")
    }

    const onCHangeTeacherEdition = (item, selectedType) => {
      const url = item.url || "";
      const pgEd = find(teacherEdition, (k) => k.pageId == item.pageId);
      const _teacherEdition = teacherEdition ? cloneDeep(teacherEdition) : [];
      if (pgEd) {
        if (selectedType === 'book') {
          pgEd.resource = '';
          pgEd.edBookData = item;
          pgEd.selectedType = 'book';
        } else if (selectedType === 'uploader') {
          pgEd.resource = '';
          pgEd.selectedType = 'uploader';
          pgEd.edBookData = null;
          pgEd.imageData = item?.imageData;
        }
        _teacherEdition[findIndex(teacherEdition, (k) => k.pageId == item.pageId)] = pgEd;
      } else {
        if (selectedType === 'book') {
          _teacherEdition.push({
            pageId: item.pageId,
            resource: '',
            edBookData: item,
            selectedType: 'book',
          });
        } else if (selectedType === 'uploader') {
          _teacherEdition.push({
            pageId: item.pageId,
            resource: "",
            selectedType: 'uploader',
            edBookData: null,
            imageData: item?.imageData
          });
        }
      }
      setTeacherEdition(_teacherEdition);
      updateBookData(
        { teacherEdition: _teacherEdition },
        `Teacher edition  page updated!`,
        'success',
      );
      if (editBook?.id) {
          logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
              action: 'teacher_edition_update',
              pageId: item.pageId,
              type: selectedType
          });
      }
    };

    const onChangeEngage = (item) => {
        const pgEd = find(engage, (k) => k.pageId == item.pageId);
        const _teacherEdition = engage ? cloneDeep(engage) : [];
        if (pgEd) {
            pgEd.imageData = item?.imageData;
            pgEd.showOptions = item?.showOptions || 'units';
            if(!pgEd.id){
              pgEd.id = v4();
            }
          _teacherEdition[findIndex(engage, (k) => k.pageId == item.pageId)] = pgEd;
        } else {
            _teacherEdition.push({
              pageId: item.pageId,
              id: v4(),
              imageData: item?.imageData || [],
              showOptions: item?.showOptions || 'units',
            });
          }
          const sortedData = _teacherEdition.sort((a, b) => a.pageId - b.pageId);
        setEngage(sortedData);
        updateBookData(
          { engage: sortedData },
          `Engage  page updated!`,
          'success',
        );
      };

      const onRemoveEngage = (item) => {
        const pgEdindex = findIndex(engage, k => k.pageId == item.pageId)
        const _engage = cloneDeep(engage)
        if (pgEdindex >= 0) {
            _engage.splice(pgEdindex, 1)
            setEngage(_engage)
      }
      updateBookData({ engage: _engage }, `Engage  page removed!`, "error")
    }

    const onCHangeTeacherEditionDesc = (item, selectedType,pageId) => {
      const pgEd = find(teacherEdition, (k) => k.pageId == pageId);
      const _teacherEdition = teacherEdition ? cloneDeep(teacherEdition) : [];
    const url = item.url || "";
      if (pgEd) {
        if (selectedType === 'book') {
          pgEd.resource = '';
          pgEd.edBookData = item;
          pgEd.selectedType = 'book';
        } else if (selectedType === 'uploader') {
          pgEd.resource = url;
          pgEd.selectedType = 'uploader';
          pgEd.edBookData = null;
        }
        _teacherEdition[findIndex(teacherEdition, (k) => k.pageId == pageId)] = pgEd;
      } else {
        if (selectedType === 'book') {
          _teacherEdition.push({
            pageId: pageId,
            resource: '',
            edBookData: item,
            selectedType: 'book',
          });
        } else if (selectedType === 'uploader') {
          _teacherEdition.push({
            pageId: pageId,
            resource: url,
            selectedType: 'uploader',
            edBookData: null
          });
        }
      }
      setTeacherEdition(_teacherEdition);
      updateBookData(
        { teacherEdition: _teacherEdition },
        `Teacher edition  page updated!`,
        'success',
      )
    }
    const onRemoveTeacherEdition = () => {
        const pgEdindex = findIndex(teacherEdition, k => k.pageId == pg.pageId)
        const _teacherEdition = cloneDeep(teacherEdition)
        if (pgEdindex >= 0) {
            _teacherEdition.splice(pgEdindex, 1)
            setTeacherEdition(_teacherEdition)
        }
        updateBookData({ teacherEdition: _teacherEdition }, `Teacher edition  page removed!`, "error")
    }
    const onChangeLessionPlan = (data) => {
        const lessionPlanIndex = findIndex(lessonPlan, k => k.page == data.page)
        const _lessonPlan = lessonPlan ? cloneDeep(lessonPlan) : []
        if (lessionPlanIndex >= 0) {
            _lessonPlan[lessionPlanIndex] = data
        } else {
            _lessonPlan.push({
                page: pg.pageId,
                ...data
            })
        }
        setLessonPlan(uniqBy(_lessonPlan, "page"))
        updateBookData({ lessonPlan: uniqBy(_lessonPlan, "page") }, "Lesson plan updated!", "success")
    }
    const onRemoveLessionPlan = (pageId) => {
        const lessionPlanIndex = findIndex(lessonPlan, k => k.page == pageId)
        const _lessonPlan = cloneDeep(lessonPlan)
        if (lessionPlanIndex >= 0) {
            _lessonPlan.splice(lessionPlanIndex, 1)
            setLessonPlan(_lessonPlan)
            updateBookData({ lessonPlan: _lessonPlan }, "Lession plan removed!", "error")
        }

    }

    const onChangeSuperLesson = (data) => {
        const superLessonIndex = findIndex(superLesson, k => k.page == data.page)
        const _superlesson = superLesson ? cloneDeep(superLesson) : []
        if (superLessonIndex >= 0) {
            _superlesson[superLessonIndex] = data
        } else {
            _superlesson.push({
                page: pg.pageId,
                ...data
            })
        }
        setSuperLesson(uniqBy(_superlesson, "page"))
        updateBookData({ superLesson: uniqBy(_superlesson, "page")}, "super Lesson is updated!", "success")
    }
    const onRemoveSuperLesson = (pageId) => {
        const superLessonIndex = findIndex(superLesson, k => k.page == pageId)
        const _superlesson = cloneDeep(superLesson)
        if (superLessonIndex >= 0) {
            _superlesson.splice(superLessonIndex, 1)
            setSuperLesson(_superlesson)
            updateBookData({ superLesson: _superlesson }, "super Lesson is removed!", "error")
            if (editBook?.id) {
                logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                    action: 'super_lesson_removed',
                    pageId: pageId
                });
            }
        }

    }

    const onChangeDifferentiationLesson = (data) => {
        const superLessonIndex = findIndex(differentiationLesson, k => k.page == data.page)
        const _superlesson = differentiationLesson ? cloneDeep(differentiationLesson) : []
        if (superLessonIndex >= 0) {
            _superlesson[superLessonIndex] = data
        } else {
            _superlesson.push({
                page: pg.pageId,
                ...data
            })
        }
        setDifferentiationLesson(uniqBy(_superlesson, "page"))
        updateBookData({ differentiationLesson: uniqBy(_superlesson, "page") }, "Differentiation is updated!", "success")
    }
    const onRemoveDifferentiationLesson = (pageId) => {
        const superLessonIndex = findIndex(differentiationLesson, k => k.page == pageId)
        const _superlesson = cloneDeep(differentiationLesson)
        if (superLessonIndex >= 0) {
            _superlesson.splice(superLessonIndex, 1)
            setDifferentiationLesson(_superlesson)
            updateBookData({ differentiationLesson: _superlesson }, "Differentiation Lesson is removed!", "error")
        }

    }

     const onChangeSentenceStarter = (data) => {
        const superLessonIndex = findIndex(sentenceStarter, k => k.page == data.page)
        const _superlesson = sentenceStarter ? cloneDeep(sentenceStarter) : []
        if (superLessonIndex >= 0) {
            _superlesson[superLessonIndex] = data
        } else {
            _superlesson.push({
                page: pg.pageId,
                ...data
            })
        }
        setSentenceStareter(uniqBy(_superlesson, "page"))
        updateBookData({ sentence_starter_data: uniqBy(_superlesson, "page") }, "Sentence Starter plan updated!", "success")
    }
    const onRemoveSentenceStarter = (pageId) => {
        const superLessonIndex = findIndex(sentenceStarter, k => k.page == pageId)
        const _superlesson = cloneDeep(sentenceStarter)
        if (superLessonIndex >= 0) {
            _superlesson.splice(superLessonIndex, 1)
            setSentenceStareter(_superlesson)
            updateBookData({ sentence_starter_data: _superlesson }, "Sentence Starter removed!", "error")
        }
    }

    const onRemoveRubricsPlan = (pageId) => {
        const rubricsPlanIndex = findIndex(rubricsPlan, k => k.page == pageId)
        const _rubricsPlan = cloneDeep(rubricsPlan)
        if (rubricsPlanIndex >= 0) {
            _rubricsPlan.splice(rubricsPlanIndex, 1)
            setRubricsPlan(_rubricsPlan)
            updateBookData({ rubrics: _rubricsPlan }, "Rubrics  removed!", "error")
        }

    }
    const onChangeAssignmentPlan = (data) => {
        const assignmentPlanIndex = findIndex(assignmentPlan, k => k.page == data.page)
        const _assignmentPlan = assignmentPlan ? cloneDeep(assignmentPlan) : []
        if (assignmentPlanIndex >= 0) {
            _assignmentPlan[assignmentPlanIndex] = data
        } else {
            _assignmentPlan.push(data)
        }
        setAssignmentPlan(uniqBy(_assignmentPlan, "page"))
        updateBookData({ assignmentPlan: uniqBy(_assignmentPlan, "page") }, "Assignment plan updated!", "success")
    }
    const onChangeGameAiContent = (ai_content) => {
        set_game_ai_content(ai_content)
        updateBookData({ ai_content:ai_content }, "Game AI content updated!", "success")
    }
    // for unit quiz
    const onChangeUnitExamPlan = (data) => {
      setUnitExam((prev = []) => {
        const updatedExams = (() => {
          const existingIndex = prev?.findIndex((k) => k.page === data.page);
          if (existingIndex >= 0) {
            return prev.map((item, index) =>
              index === existingIndex ? data : item
            );
          }
          return [...prev, data];
        })();

        const uniqueExams = uniqBy(updatedExams, "page");

        updateBookData(
          { unit_exam: uniqueExams },
          "Assignment plan updated!",
          "success"
        );

        return uniqueExams;
      });
    };


    const onChangeWorkbookPlan = (data) => {
        const workbookPlanIndex = findIndex(workbook_plan, k => k.page == data.page)
        const _workbook_plan = workbook_plan ? cloneDeep(workbook_plan) : []
        if (workbookPlanIndex >= 0) {
            _workbook_plan[workbookPlanIndex] = data
        } else {
            _workbook_plan.push(data)
        }
        setWorkbook_plan(uniqBy(_workbook_plan, "page"))
        updateBookData({ workbook_plan: uniqBy(_workbook_plan, "page") }, "Workbook plan updated!", "success")
    }

    const onChangeAssignmentBookLinkPlan = (data) => {
        const assignmentLinkPlanIndex = findIndex(assignment_book_link_plan, k => k.page == data.page)
        const _assignment_link_plan = assignment_book_link_plan ? cloneDeep(assignment_book_link_plan) : []
        if (assignmentLinkPlanIndex >= 0) {
            _assignment_link_plan[assignmentLinkPlanIndex] = data
        } else {
            _assignment_link_plan.push(data)
        }
        setAssignment_book_link_plan(uniqBy(_assignment_link_plan, "page"))
        updateBookData({ assignment_book_link_plan: uniqBy(_assignment_link_plan, "page") }, "Assignment book link plan updated!", "success")
    }

    const onChangeMainBook = (data) => {
        const mainBookIndex = findIndex(main_book, k => k.page == data.page)
        const _main_book = main_book ? cloneDeep(main_book) : []
        if (mainBookIndex >= 0) {
            _main_book[mainBookIndex] = data
        } else {
            _main_book.push(data)
        }
        setMainBook(uniqBy(_main_book, "page"))
        updateBookData({ main_book: uniqBy(_main_book, "page") }, "Assessment book updated!", "success")
        if (editBook?.id) {
            logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                action: 'assessment_book_update',
                pageId: data.page,
                plan: data
            });
        }
    }
    const onChangeRunricsPlan = (data) => {
        const rubricsPlanIndex = findIndex(rubricsPlan, k => k.page == data.page)
        const _rubricsPlan = rubricsPlan ? cloneDeep(rubricsPlan) : []
        if (rubricsPlanIndex >= 0) {
            _rubricsPlan[rubricsPlanIndex] = data
        } else {
            _rubricsPlan.push(data)
        }
        setRubricsPlan(uniqBy(_rubricsPlan, "page"))
        updateBookData({ rubrics: uniqBy(_rubricsPlan, "page") }, "Rubrics plan updated!", "success")
        if (editBook?.id) {
            logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                action: 'rubrics_update',
                pageId: data.page,
                plan: data
            });
        }
    }
    const onRemoveAssignmentPlan = (pageId) => {
        const assignmentPlanIndex = findIndex(assignmentPlan, k => k.page == pageId)
        const _assignmentPlan = cloneDeep(assignmentPlan)
        if (assignmentPlanIndex >= 0) {
            _assignmentPlan.splice(assignmentPlanIndex, 1)
            setAssignmentPlan(_assignmentPlan)
            updateBookData({ assignmentPlan: _assignmentPlan }, "Assignment plan removed!", "error")
            if (editBook?.id) {
                logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                    action: 'quiz_removed',
                    pageId: pageId
                });
            }
        }
    }

    const onRemoveUnitExamPlan = (pageId) => {
    setUnitExam((prev) => {
        const indexToRemove = prev.findIndex((exam) => exam.page === pageId);

        // If item doesn't exist, return early
        if (indexToRemove === -1) {
        return prev;
        }

        // Create new array without the removed item
        const updatedExams = [
        ...prev.slice(0, indexToRemove),
        ...prev.slice(indexToRemove + 1),
        ];

        // Update book data
        updateBookData(
        { unit_exam: updatedExams },
        "Assignment plan removed!",
        "error"
        );

        return updatedExams;
    });
    };
    const onRemoveWorkbookPlan = (pageId) => {
        const workbookPlanIndex = findIndex(workbook_plan, k => k.page == pageId)
        const _workbook_plan = cloneDeep(workbook_plan)
        if (workbookPlanIndex >= 0) {
            _workbook_plan.splice(workbookPlanIndex, 1)
            setWorkbook_plan(_workbook_plan)
            updateBookData({ workbook_plan: _workbook_plan }, "Workbook plan removed!", "error")
        }

    }

    const onRemoveAssignmentBookLinkPlan = (pageId) => {
        const workbookPlanIndex = findIndex(assignment_book_link_plan, k => k.page == pageId)
        const _workbook_plan = cloneDeep(assignment_book_link_plan)
        if (workbookPlanIndex >= 0) {
            _workbook_plan.splice(workbookPlanIndex, 1)
            setAssignment_book_link_plan(_workbook_plan)
            updateBookData({ assignment_book_link_plan: _workbook_plan }, "Assignment book link plan removed!", "error")
        }
    }

    const onRemoveMainbookPlan = (pageId) => {
        const mainbookindex = findIndex(main_book, k => k.page == pageId)
        const _main_book = cloneDeep(main_book)
        if (mainbookindex >= 0) {
            _main_book.splice(mainbookindex, 1)
            setMainBook(_main_book)
            updateBookData({ main_book: _main_book }, "main book removed!", "error")
        }

    }
    const onUpdateSubTopics = (data) => {
        setSubTopics(data)
        updateBookData({ subTopics: data }, "Units updated!", "success")
    }
    const onCreateOrUpdate = async () => {
        const errors = []
        const hasMaskedNumber = find(pages, p => p.NumberMasked)
        const _pages = []
        map(pages, (p, i) => {
            try {
                if (hasMaskedNumber) {
                    if (i == 0) {
                        if (!p.NumberMasked) {
                            // p.NumberMasked = convertToRoman(1)
                        }
                    }
                    else {
                        if (!p.NumberMasked) {
                            const maskNumber = getNextNumberMask(get(_pages[i - 1], "NumberMasked", convertToRoman(1)), get(_pages[i - 2], "NumberMasked"))
                            if (maskNumber != p.NumberMasked) {
                                if (!p.NumberMasked) {
                                    // p.NumberMasked = maskNumber;
                                }
                            }
                        }
                    }
                }
            } catch (error) {
                Sentry.captureException(`428 Error during onCreateOrUpdate: ${error}`);
                console.log(error, "num mask error", error);
            }

            _pages.push(p);
        })
        const book = {
            count,
            description,
            idTypeBook: '1',
            img: cover,
            resource: cover,
            stateBook: 'active',
            pages: _pages,
            pagesTeacher: filter(pagesTeacher, pg => pg.resource),
            subTopics,
            isNotAssignable,
            lessonPlan,
            teacherEdition: filter(teacherEdition, pg => pg.resource),
            assignmentPlan,
            workbook_plan,
            assignment_book_link_plan,
            main_book,
            demoPages,
            hyperlinks,
            onlyTeacher,
            teacherEditionBook,
            level,
            language,
            storyId,
            type,
            printable,
            is_assessment_book: markAsAssessment,
            markAsMainBook,
            book_type: selectedValue,
        }
        if (!book.description || book.description.length == 0) {
            errors.push({ type: 'description_error', message: 'Book title required.\n' })
        }
        if (!book.img || book.img.length == 0) {
            errors.push({ type: 'cover_error', message: 'Cover image required.\n' })
        }
        const hasNotResonPage = filter(pages, pg => !pg.resource)
        if (hasNotResonPage.length > 0) {
            errors.push({ type: 'page_error_img', message: `Page image on page id ${hasNotResonPage.map(k => k.pageId).join(",")} is required \n` })
        }

        setErrors(errors)
        if (errors.length == 0) {
            setloading(true)
            if (editBook) {
                await dispatch(handleUpdateBook(editBook.id, book))
                logBookActivity('update', editBook.id, book.description || 'Unknown Book', {
                    action: 'book_update',
                    changes: {
                        description: book.description,
                        level: book.level,
                        language: book.language,
                        type: book.type,
                        printable: book.printable,
                        markAsMainBook: book.markAsMainBook,
                        onlyTeacher: book.onlyTeacher,
                        isNotAssignable: book.isNotAssignable,
                        markAsAssessment: book.is_assessment_book,
                        book_type: book.book_type,
                        totalPages: book.pages?.length
                    }
                });
                setAlertSakeBar({
                    open: true,
                    message: "Book updated successfully",
                    severity: "success"
                })
                setSaveModal(false)
            } else {
                const cBook = await dispatch(handleCreateBook(book))
                if (has(cBook, "id")) {
                    logBookActivity('create', cBook.id, book.description || 'Unknown Book', {
                        action: 'book_create',
                        level: book.level,
                        language: book.language,
                        type: book.type,
                        totalPages: book.pages?.length
                    });
                    setSaveModal(false)
                    setAlertSakeBar({
                        open: true,
                        message: "Book created successfully",
                        severity: "success"
                    })
                    setTimeout(() => {
                        navigate(`/add-book?bookId=${cBook.id}`)
                        location.reload()
                    }, 1000)

                } else {
                    setErrors([{ type: 'book_creation', message: 'Error in book creation please retry!\n' }])
                }
            }
            setloading(false)
        } else {
            setloading(false)
        }

    }

    const updateBookData = async (book, message, messageType) => {
        setdataloader(true)
        try {
            if (editBook && editBook.id) {
                setUpdateLoader(true)
                const data = await dispatch(handleUpdateBook(editBook.id, book))
                if (has(data, "id")) {
                    const updatedFields = Object.keys(book);
                    const messageLower = (message || '').toLowerCase();
                    let activityType = 'update';
                    if (messageLower.includes('removed') || messageLower.includes('removed!')) {
                        activityType = 'update';
                    } else if (messageLower.includes('added') || messageLower.includes('added!') || messageLower.includes('uploaded successfully')) {
                        activityType = 'update';
                    }
                    const action = getActionFromFieldsAndMessage(updatedFields, message);
                    logBookActivity(activityType, editBook.id, editBook.description || 'Unknown Book', {
                        action: action,
                        updatedFields: updatedFields,
                        message: message
                    });
                    setAlertSakeBar({
                        open: true,
                        message: message ? message : "Book updated successfully",
                        severity: messageType ? messageType : "success"
                    })
                    setUpdateLoader(false)
                } else {
                    setAlertSakeBar({
                        open: true,
                        message: "having some issue while updating book.",
                        severity: "error"
                    })
                }
            }  
        } catch (error) {
            MessageAlert.error(`having some issue while updating book.`)
            console.log("having some issue while updating book.", error)
            Sentry.captureException(`429 Error during updateBookData: ${error}`);
            
        } finally {
            setLoaderImg(false)
            setdataloader(false)
        }
    }
    const updateBookDataByPageWithKey = async (pageId,fieldData, fieldName , message, messageType, type) => {
        setdataloader(true)
        try {
            if (editBook && editBook.id) {
                setUpdateLoader(true)
                const data = await dispatch(handleUpdateBookByPage(
                    editBook.id, pageId?pageId:pg.pageId,fieldData, fieldName
                ))
                if (data.success) {
                    MessageAlert.success( message ? message : "Book updated successfully")
                    if (type === 'ai_image') {
                        dispatch(handleAiContentStoreUpdate({
                            bookId: editBook.id, 
                            page: pageId ? pageId : pg.pageId
                        }));
                    }
                    setUpdateLoader(false)
                } else {
                    MessageAlert.error("having some issue while updating book.")
                }
            }  
        } catch (error) {
            MessageAlert.error(`having some issue while updating book.`)
            console.log("having some issue while updating book.", error)
            Sentry.captureException(`430 Error during updateBookDataByPageWithKey: ${error}`);
            
        } finally {
            setdataloader(false)
        }
    }
    const onPageIdChange = (id) => {
        const pageIndex = findIndex(pages, p => p.pageId == id)
        if (pageIndex >= 0) {
            setActiveindex(pageIndex)
        }
    }

    const onMaskIdChange = (id) => {
        
        const pageIndex = findIndex(pages, p =>
            String(p.NumberMasked).toLowerCase() === String(id).toLowerCase()
        );
        if (pageIndex >= 0) {
            setActiveindex(pageIndex);
        }
    };
    
    const closeAlert = () => {
        setAlertSakeBar({ open: false, message: '', severity: '' })
    }
    
    const closeDeleteModal = () => {
        setDeletePageModal(false)
        setPageToDelete(null)
    }
    const disableForWard = (activeIndex >= pages.length - 1)
    const disableBackWrad = activeIndex <= 0
    const pageHyperLink = find(hyperlinks, k => k.page == pg.pageId)
    const pageTeacherPage = filter(pagesTeacher, k => k.pageId == pg.pageId)
    const pacingTeacherPage = filter(pacingTeacher, k => k.pageId == pg.pageId)
    const syllabusTeacherPage = filter(syllabusTeacher, k => k.pageId == pg.pageId)
    const pagePDF = filter(pagesPDF, k => k.pageId == pg.pageId)
    const pageteacherEdition = find(teacherEdition, k => k.pageId == pg.pageId)
    const pgEngage = find(engage, k => k.pageId == pg.pageId);
    const pgLessonPlan = find(lessonPlan, k => k.page == pg.pageId)
    const pgSuperLesson = find(superLesson, k => k.page == pg.pageId)
    const pgDifferentiation = find(differentiationLesson, k => k.page == pg.pageId)
    const pgAssignmentPlan = find(assignmentPlan, k => k.page == pg.pageId)
    const pgUnitExamPlan = find(unitExam, k => k.page == pg.pageId);
    const pgWorkbookPlan = find(workbook_plan, k => k.page == pg.pageId)
    const pgAssignmentBookLinkPlan = find(assignment_book_link_plan, k => k.page == pg.pageId)
    const pgMainbook = find(main_book, k => k.page == pg.pageId)
    const pgRubricsPlan = find(rubricsPlan, k => k.page == pg.pageId)
    const pageActivities = filter(bookActivities, bk => bk.page == pg.pageId)
    const pageQuizzes = filter(bookQuizzes, bk => bk.page == pg.pageId)
    const pageTips = find(bookTips, bk => bk.page == pg.pageId)
    const pageIntrections = filter(bookIntractions, bk => bk.page == pg.pageId);
    const pgSentenceStarter = find(sentenceStarter, bk => bk.page == pg.pageId);
    return (
    <SentryWrap>
        <SpinLoader dataloader={dataloader} />
            <DeleteModal 
                deleteToggle={deletePageModal} 
                setDeleteToggle={closeDeleteModal} 
                loading={deleteLoader} 
                message={`Are you sure you want to delete page ${pageToDelete !== null ? pages[pageToDelete]?.pageId || pageToDelete + 1 : activeIndex + 1}? This action will permanently remove all user-created content associated with this page.`} 
                onDelete={onRemove} 
            />
            <DeleteModal 
                deleteToggle={addPageModal} 
                setDeleteToggle={setAddPageModal} 
                loading={addLoader} 
                colorSchema="primary"
                buttonTitle="Add Page"
                message={`A new page will be added ${inserationType === 'before' ? 'before' : 'after'} page ${pages[activeIndex]?.pageId || activeIndex + 1}. Do you want to continue?`} 
                onDelete={onAddPageAtCurrent} 
            />
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={alertSakeBar.open}
                autoHideDuration={3000}
                onClose={closeAlert}>
                <Alert onClose={() => { setAlertSakeBar({ open: false, message: '' }) }} severity={alertSakeBar.severity}>
                    <strong>ALERT:</strong> {alertSakeBar.message}
                </Alert>
            </Snackbar>
            <Modal
                open={saveModal}
                onClose={() => {
                    setSaveModal(false)
                    setErrors([])
                }}
                style={{ height: '100%', width: '100%' }}
            >
                <ModalContent>
                    <Row style={{ justifyContent: "space-between" }}>
                        <TitleText>{editBook ? 'Update Book' : 'Add Book'}</TitleText>
                        <IconButton onClick={() => setSaveModal(false)} style={{ padding: 0, marginRight: 10 }}>
                            <Close color="secondary" />
                        </IconButton>
                    </Row>
                    <ModalConfigArea>
                        <Row>
                            <Col xs={24} lg={12} style={{ marginBottom: 20 }}>
                                <CoverText>Cover image</CoverText>
                                <PageImagePicker
                                    src={cover}
                                    onChange={item => {
                                        setCover(item.url);
                                        if (editBook?.id) {
                                            logBookActivity('update', editBook.id, editBook.description || 'Unknown Book', {
                                                action: 'cover_image_change',
                                                url: item.url
                                            });
                                        }
                                    }}
                                    pageId={pg.pageId}
                                    hasDescription={false}
                                />
                            </Col>
                            <Col xs={24} lg={12} style={{ paddingLeft: 10, paddingTop: 10 }}>
                                <Row justify="start" style={{ marginBottom: 20, }}>
                                    <TextField
                                        id="title"
                                        name="title"
                                        label="Book title"
                                        InputLabelProps={{ shrink: true, required: true }}
                                        type="text"
                                        required
                                        variant="outlined"
                                        onChange={e => {
                                            setDescription(e.target.value)
                                        }}
                                        value={description}
                                    />
                                </Row>
                                {/* <Row justify="start" style={{ marginBottom: 20, }}>
                                    <TextField
                                        id="teacherEditionBook"
                                        name="teacherEditionBook"
                                        label="Book Id for teacher edition book."
                                        required={false}
                                        InputLabelProps={{ shrink: true }}
                                        type="text"
                                        variant="outlined"
                                        onChange={e => {
                                            setTeacherEditionBook(e.target.value)
                                        }}
                                        value={teacherEditionBook}
                                    />
                                </Row> */}
                                <Row justify="start" style={{ marginBottom: 20, }} gutter={[24,24]}>
                                    <Col xs={24} lg={12}>
                                        <TextField
                                            id="demoPageFrom"
                                            name="demoPageFrom"
                                            label="Demo page start from."
                                            required={false}
                                            InputLabelProps={{ shrink: true }}
                                            type="text"
                                            variant="outlined"
                                            onChange={e => {
                                                if (demoPages) {
                                                    setDemoPages({ ...demoPages, from: e.target.value })
                                                } else {
                                                    setDemoPages({ from: e.target.value, to: '' })
                                                }
                                            }}
                                            value={get(demoPages, "from")}
                                        />
                                    </Col>
                                    <Col xs={24} lg={12}>
                                        <TextField
                                            id="demoPageTo"
                                            name="demoPageTo"
                                            label="Demo page end to."
                                            required={false}
                                            InputLabelProps={{ shrink: true }}
                                            type="text"
                                            variant="outlined"
                                            onChange={e => {
                                                if (demoPages) {
                                                    setDemoPages({ ...demoPages, to: e.target.value })
                                                } else {
                                                    setDemoPages({ to: e.target.value, from: '' })
                                                }
                                            }}
                                            value={get(demoPages, "to")}
                                        />
                                    </Col>

                                </Row>
                                <Row style={{marginBottom:20}}>
                                    <Col xs={12} lg={12}>
                                        <FormControlLabel
                                            classes={{
                                                root: classes.rootDifFull,
                                                label: classes.label,
                                            }}
                                            control={
                                                <Switch
                                                    classes={{
                                                        sizeSmall: classes.sizeSmall,
                                                        checked: classes.checkedSwitch
                                                    }}
                                                    checked={Boolean(printable)}
                                                    id="Printable"
                                                    onChange={e => {
                                                        setPrintable(e.target.checked)
                                                    }}
                                                    name="Printable"
                                                    color="primary"
                                                    size="small"
                                                />
                                            }
                                            label="Make All Pages Printable"
                                        />
                                    </Col>
                                    {/* <Col xs={12} lg={12}>
                                        <FormControlLabel
                                            classes={{
                                                root: classes.rootDifFull,
                                                label: classes.label,
                                            }}
                                            control={
                                                <Switch
                                                    classes={{
                                                        sizeSmall: classes.sizeSmall,
                                                        checked: classes.checkedSwitch
                                                    }}
                                                    checked={Boolean(count)}
                                                    id="count"
                                                    onChange={e => {
                                                        setCount(e.target.checked)
                                                    }}
                                                    name="count"
                                                    color="primary"
                                                    size="small"
                                                />
                                            }
                                            label="Count"
                                        />
                                    </Col> */}
                                    {orderedBook && (
                                        <Col xs={12} lg={12}>
                                            <FormControlLabel
                                                disabled={markAsMainBookOrder?.id && !isMarkAsMainBook}
                                                classes={{
                                                    root: classes.rootDifFull,
                                                    label: classes.label,
                                                }}
                                                control={
                                                    <Switch
                                                        classes={{
                                                            sizeSmall: classes.sizeSmall,
                                                            checked: classes.checkedSwitch
                                                        }}
                                                        checked={Boolean(markAsMainBook)}
                                                        id="markAsMainBook"
                                                        onChange={e => {
                                                            setMarkAsMainBook(e.target.checked)
                                                        }}
                                                        name="markAsMainBook"
                                                        color="primary"
                                                        size="small"
                                                    />
                                                }
                                                label="Mark as main book of group"
                                            />
                                        </Col>
                                    )}
                                    <Col xs={12} lg={12} style={{marginTop:10}}>
                                        <FormControlLabel
                                            classes={{
                                                root: classes.rootDifFull,
                                                label: classes.label,
                                            }}
                                            control={
                                                <Switch
                                                    classes={{
                                                        sizeSmall: classes.sizeSmall,
                                                        checked: classes.checkedSwitch
                                                    }}
                                                    checked={Boolean(onlyTeacher)}
                                                    id="onlyTeacher"
                                                    onChange={e => {
                                                        setOnlyTeacher(e.target.checked)
                                                    }}
                                                    name="onlyTeacher"
                                                    color="primary"
                                                    size="small"
                                                />
                                            }
                                            label="Only for teacher"
                                        />
                                    </Col>
                                    {orderedBook && (
                                        <Col xs={12} lg={12} style={{ marginTop: 10 }}>
                                            <FormControlLabel
                                                disabled={AsessmentBookOrder?.id && !isAssessment}
                                                classes={{
                                                    root: classes.rootDifFull,
                                                    label: classes.label,
                                                }}
                                                control={
                                                    <Switch
                                                        classes={{
                                                            sizeSmall: classes.sizeSmall,
                                                            checked: classes.checkedSwitch
                                                        }}
                                                        checked={Boolean(markAsAssessment)}
                                                        id="markAsAssessment"
                                                        onChange={e => {
                                                            setMarkAsAssessment(e.target.checked)
                                                        }}
                                                        name="markAsAssessment"
                                                        color="primary"
                                                        size="small"
                                                    />
                                                }
                                                label="mark as assessment book"
                                            />
                                        </Col>
                                    )}
                                </Row>
                                {/* <Row justify="start" style={{ marginBottom: 20, }}>
                                    <FormControlLabel
                                        classes={{
                                            root: classes.rootDifFull,
                                            label: classes.label,
                                        }}
                                        control={
                                            <Switch
                                                classes={{
                                                    sizeSmall: classes.sizeSmall,
                                                    checked: classes.checkedSwitch
                                                }}
                                                checked={Boolean(count)}
                                                id="count"
                                                onChange={e => {
                                                    setCount(e.target.checked)
                                                }}
                                                name="count"
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label="Count"
                                    />
                                </Row>
                                <Row justify="start" style={{ marginBottom: 20, }}>
                                    <FormControlLabel
                                        classes={{
                                            root: classes.rootDifFull,
                                            label: classes.label,
                                        }}
                                        control={
                                            <Switch
                                                classes={{
                                                    sizeSmall: classes.sizeSmall,
                                                    checked: classes.checkedSwitch
                                                }}
                                                checked={Boolean(onlyTeacher)}
                                                id="onlyTeacher"
                                                onChange={e => {
                                                    setOnlyTeacher(e.target.checked)
                                                }}
                                                name="onlyTeacher"
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label="Only for teacher"
                                    />
                                </Row> */}
                                <Tag style={{marginTop:20}} height={20}><Star style={{ height: '12px', margin: '-1px 4px 0px 0px', width: '12px' }} /> NOTE</Tag>
                                <Note style={{ marginBottom: 10 }}>BOOK IS NOT ASSIGNABLE means This book cannot be assigned to a teacher or student as the main book. </Note>
                                <Row justify="start" style={{ marginBottom: 20, }}>
                                    <FormControlLabel
                                        classes={{
                                            root: classes.rootDifFull,
                                            label: classes.label,
                                        }}
                                        control={
                                            <Switch
                                                disabled={editBook && editBook.id && ['49', '33', '41', '43'].includes(editBook.id)}
                                                classes={{
                                                    sizeSmall: classes.sizeSmall,
                                                    checked: classes.checkedSwitch
                                                }}
                                                checked={Boolean(isNotAssignable)}
                                                id="isNotAssignable"
                                                onChange={e => {
                                                    setIsNotAssignable(e.target.checked)
                                                }}
                                                name="isNotAssignable"
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label="Book is not Assignable (Mark as non main book)"
                                    />
                                </Row>
                                <Row justify="start" style={{ marginBottom: 20, }}>
                                    <FormControlLabel
                                        classes={{
                                            root: classes.rootDifFull,
                                            label: classes.label,
                                        }}
                                        control={
                                            <Switch
                                                classes={{
                                                    sizeSmall: classes.sizeSmall,
                                                    checked: classes.checkedSwitch
                                                }}
                                                checked={type === "story"}
                                                id="type_story"
                                                onChange={e => {
                                                    setType(e.target.checked ? "story" : null)
                                                }}
                                                name="type_story"
                                                color="primary"
                                                size="small"
                                            />
                                        }
                                        label="Story book"
                                    />
                                </Row>
                                {type === "story" ? <Row justify="start" style={{ marginBottom: 20, }}>
                                    <TextField
                                        id="storyId"
                                        name="storyId"
                                        label="storyId"
                                        required={false}
                                        InputLabelProps={{ shrink: true }}
                                        type="text"
                                        variant="outlined"
                                        onChange={e => {
                                            setStoryId(e.target.value)
                                        }}
                                        value={storyId}
                                    />
                                </Row> : null}

                                <Row style={{ marginBottom: 30, marginRight: 0, marginLeft: 0 }} className="floatingLabelBG">
                                    <FormControl variant="outlined" className={classes.formControl}>
                                        <InputLabel id="type">Level</InputLabel>
                                        <Select
                                            labelId="level"
                                            id="level"
                                            value={level || ''}
                                            onChange={(v) => {
                                                setlevel(v.target.value)
                                            }}
                                            label="Type"
                                        >
                                            <MenuItem value={''}>Other</MenuItem>
                                            <MenuItem value={'BASICO'}>BASICO</MenuItem>
                                            <MenuItem value={'INTERMEDIO'}>INTERMEDIO</MenuItem>
                                            <MenuItem value={'AVANZADO'}>AVANZADO</MenuItem>

                                        </Select>
                                    </FormControl>
                                </Row>
                                {editBook?.book_type === 'non_native_spanish' && (
                                    <Row style={{ marginBottom: 30, marginRight: 0, marginLeft: 0 }} className="floatingLabelBG">
                                        <FormControl variant="outlined" className={classes.formControl}>
                                            <InputLabel id="type">Vocabulary Language</InputLabel>
                                            <Select
                                                labelId="language"
                                                id="language"
                                                value={language || ''}
                                                onChange={(v) => {
                                                    setLanguage(v.target.value)
                                                }}
                                                label="Type"
                                            >
                                                <MenuItem value={'spanish'}>Spanish</MenuItem>
                                                <MenuItem value={'french'}>French</MenuItem>

                                            </Select>
                                        </FormControl>
                                    </Row>
                                )}
                                {bookErrors.length > 0 ? <Row style={{ marginTop: 10, marginRight: 0, marginLeft: 0, flexDirection: "column", display: "flex" }}>
                                    {bookErrors.map(v => (<Typography variant="subtitle2" key={v.type} style={{ whiteSpace: "pre-wrap" }} color="error">
                                        * {get(v, "message")}
                                    </Typography>))}
                                </Row> : null}
                                <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                                    <Button fullWidth onClick={onCreateOrUpdate} variant="contained" color="primary">    {loading ? <Loading white size={15} /> : null}  {editBook ? "Update" : "Create"}</Button>
                                </Row>
                            </Col>
                        </Row>
                    </ModalConfigArea>
                </ModalContent>
            </Modal>
            
            <Toolbar>                
                <LeftSection>
                    <Tooltip 
                        title={
                            (() => {
                                const activeInfo = getActiveUnitInfo();
                                if (!activeInfo) return "No active section";
                                return (
                                    <div>
                                        <div style={{ fontWeight: 600, marginBottom: 4 }}>
                                            Currently Viewing:
                                        </div>
                                        <div>{activeInfo.unit}</div>
                                        {activeInfo.subunit && (
                                            <div style={{ fontSize: 12, marginTop: 2 }}>
                                                → {activeInfo.subunit}
                                            </div>
                                        )}
                                    </div>
                                );
                            })()
                        }
                        arrow
                        placement="bottom"
                    >
                        <Button
                            variant="contained"
                            onClick={() => setNavigationOpen(true)}
                            sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                                px: 2,
                                py: 0.75,
                                fontWeight: 600,
                                boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
                                '&:hover': {
                                    boxShadow: '0 4px 12px rgba(25, 118, 210, 0.4)',
                                },
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: 0.25,
                                minHeight: 'auto'
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <MenuBook sx={{ fontSize: 18 }} />
                                <span>Navigation Menu</span>
                            </div>
                            {(() => {
                                const activeInfo = getActiveUnitInfo();
                                if (activeInfo) {
                                    return (
                                        <div style={{ 
                                            fontSize: '10px', 
                                            fontWeight: 400, 
                                            opacity: 0.85,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            maxWidth: '180px',
                                            lineHeight: 1.2
                                        }}>
                                            {activeInfo.unit}{activeInfo.subunit ? ` → ${activeInfo.subunit}` : ''}
                                        </div>
                                    );
                                }
                                return null;
                            })()}
                        </Button>
                    </Tooltip>
                </LeftSection>

                <RightSection>
                    <NavigationInputs
                        pages={pages}
                        pageId={pageid}
                        maskId={maskId}
                        onPageIdChange={onPageIdChange}
                        onMaskIdChange={onMaskIdChange}
                    />
                </RightSection>
            </Toolbar>
            <Wrapper className="slideLftRghtUpr">
                <Row style={{ height: 50 }}>
                    <Col span={1}>
                        <ButtonContainer
                            ref={backBtnRef}
                            disabled={disableBackWrad}
                            onClick={onBackward}
                            left={0} className="cstmLeftArow">
                            <ArrowBackIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>
                    </Col>
                    <Col span={22} style={{ justifyContent: "flex-end", display: "flex", flexDirection: "row" }}>
                    <FormControl size="small" variant="outlined" className={classes.formControl} style={{width:"185px", display:"flex", flexDirection:"column",justifyContent:"center"}}>
                        {/* <InputLabel id="grade_type" style={{ backgroundColor: "#fff", width: 'max-content' }}>Display Grade as</InputLabel> */}
                       <Select
                            labelId="grade_type"
                            value={selectedValue || ""}
                            onChange={handleChange}
                            placeholder='Select Book Type'
                            disabled={disableNative}
                            displayEmpty 
                        >
                            <MenuItem value={""} disabled>Select Book Type</MenuItem>
                            <MenuItem value={"native_spanish"}>Native spanish</MenuItem>
                            <MenuItem value={"non_native_spanish"}>Non native spanish</MenuItem>
                                          
                        </Select>
                    </FormControl>
                      <div className='addPagesBtn'>
                        <Dropdown menu={addPageMenuProps} trigger={['click']} disabled={updateLoader}>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                disabled={updateLoader}
                                startIcon={<Add />}
                            >
                                Add Page
                            </Button>
                        </Dropdown>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            disabled={updateLoader}
                            onClick={() => { setSaveModal(true) }}
                        >
                            Save
                        </Button>
                       </div> 
                        {pages.length > 1 ? <IconButton onClick={() => {
                            setPageToDelete(activeIndex);
                            setDeletePageModal(true);
                        }}>
                            <Delete disabled={updateLoader} />
                        </IconButton> : null}
                    </Col>
                    <Col span={1}>
                        <ButtonContainer
                            ref={forwardBtnRef}
                            disabled={disableForWard}
                            onClick={onForward}
                            right={0} className="cstmRghtArow">
                            <ArrowForwardIos style={{ fontSize: '40px' }} />
                        </ButtonContainer>
                    </Col>
                </Row>
                <Container className="eBookTabLftUpr">
                    <Pages
                        src={pg ? pg.resource : null}
                        onChange={onPageImageChange}
                        pageId={get(pg, "pageId")}
                        disabled={updateLoader}
                        description={get(pg, "description", "")}
                        onChangeDescription={onChangeDescription}
                        hasDescription={false}
                        bookId={search.bookId}
                        booksAllList={booksAllList}
                    />
                    <ToolsContainer>
                        <PageToolbar
                            pageId={pg.pageId}
                            numberMask={pg.NumberMasked || pg.pageId}
                            onMaskChange={onMaskChanged}
                            onBulkMaskGenerate={onBulkMaskGenerate}
                            hyperlinks={pageHyperLink}
                            teacherPage={pageTeacherPage}
                            pacingTeacherPage={pacingTeacherPage}
                            syllabusTeacherPage={syllabusTeacherPage}
                            pagesPDF={pagesPDF}
                            pagePDF={pagePDF}
                            onChangePDF={onChangePDF}
                            onRemovePDF={onRemovePDF}
                            teacherEdition={pageteacherEdition}
                            pageActivities={pageActivities}
                            pageQuizzes={pageQuizzes}
                            onChangeHyperlink={onChangeHyPerLink}
                            onChangeAnswerPage={onChangeAnswerPage}
                            onChangePacing={onChangePacing}
                            onChangeSyllabus={onChangeSyllabus}
                            onChangeAnswerDesc={onChangeAnswerDesc}
                            onChangePacingAnswerDesc={onChangePacingAnswerDesc}
                            onChangeSyllabusAnswerDesc={onChangeSyllabusAnswerDesc}
                            onCHangeTeacherEdition={onCHangeTeacherEdition}
                            onCHangeTeacherEditionDesc={onCHangeTeacherEditionDesc}
                            onRemoveAnsPage={onRemoveAnsPage}
                            onRemovePacingAnsPage={onRemovePacingAnsPage}
                            onRemoveSyllabusAnsPage={onRemoveSyllabusAnsPage}
                            onRemoveTeacherEdition={onRemoveTeacherEdition}
                            pgLessonPlan={pgLessonPlan}
                            pgSuperLesson={pgSuperLesson}
                            pgDifferentiation={pgDifferentiation}
                            pgAssignmentPlan={pgAssignmentPlan}
                            pgWorkbookPlan={pgWorkbookPlan}
                            pgAssignmentBookLinkPlan={pgAssignmentBookLinkPlan}
                            pgMainbook={pgMainbook}
                            pgRubricsPlan={pgRubricsPlan}
                            pgUnitExamPlan={pgUnitExamPlan}
                            booksAllList={booksAllList}
                            onChangeAssignmentPlan={onChangeAssignmentPlan}
                            onRemoveUnitExamPlan={onRemoveUnitExamPlan}
                            onChangeUnitExamPlan={onChangeUnitExamPlan}
                            onChangeWorkbookPlan={onChangeWorkbookPlan}
                            onChangeAssignmentBookLinkPlan={onChangeAssignmentBookLinkPlan}
                            onChangeMainBook={onChangeMainBook}
                            onChangeRunricsPlan={onChangeRunricsPlan}
                            onChangeLessionPlan={onChangeLessionPlan}
                            onChangeSuperLesson={onChangeSuperLesson}
                            onChangeDifferentiationLesson={onChangeDifferentiationLesson}
                            onChangeSentenceStarter={onChangeSentenceStarter}
                            onRemoveLessionPlan={onRemoveLessionPlan}
                            onRemoveSuperLesson={onRemoveSuperLesson}
                            onRemoveDifferentiationLesson={onRemoveDifferentiationLesson}
                            onRemoveSentenceStarter={onRemoveSentenceStarter}
                            onRemoveRubricsPlan={onRemoveRubricsPlan}
                            onRemoveAssignmentPlan={onRemoveAssignmentPlan}
                            onRemoveWorkbookPlan={onRemoveWorkbookPlan}
                            onRemoveAssignmentBookLinkPlan={onRemoveAssignmentBookLinkPlan}
                            onRemoveMainbookPlan={onRemoveMainbookPlan}
                            subTopics={subTopics}
                            onUpdateSubTopics={onUpdateSubTopics}
                            onPageIdChange={onPageIdChange}
                            page={pg}
                            bookIdVoc={bookIdVoc}
                            disabled={updateLoader}
                            bookId={get(editBook, "id")}
                            pageTips={pageTips}
                            pageIntrections={pageIntrections}
                            game_ai_content={game_ai_content}
                            onChangeGameAiContent={onChangeGameAiContent}
                            pages={pages}
                            pgDescription={pg.description}
                            pgTags={pg.tags}
                            onChangeOrUpdateDescription={onChangeOrUpdateDescription}
                            pgPrintable={pg.printable}
                            onChangePagePrintableOption={onChangePagePrintableOption}
                            is_book_printable={printable}
                            updateLoader={updateLoader}
                            setUpdateLoader={setUpdateLoader}
                            loaderImg={loaderImg}
                            setLoaderImg={setLoaderImg}
                            setdataloader={setdataloader}
                            main_book_data={main_book_data}
                            pgSentenceStarter={pgSentenceStarter}
                            setSubTopics={setSubTopics}
                            onAdminAssignmentRefetch={onAdminAssignmentRefetch}
                            pgEngage={pgEngage}
                            onChangeEngage={onChangeEngage}
                            onRemoveEngage={onRemoveEngage}
                        />
                    
                    </ToolsContainer>
                </Container>
            </Wrapper>
            
            <BookNavigation
                subTopics={subTopics}
                pages={pages}
                currentPageId={pg.pageId}
                onNavigateToPage={(pageId) => {
                    const pageIndex = findIndex(pages, p => p.pageId == pageId);
                    if (pageIndex >= 0) {
                        setActiveindex(pageIndex);
                    }
                }}
                pageId={pageid}
                maskId={maskId}
                onPageIdChange={(pageId) => {
                    setpageid(pageId);
                    onPageIdChange(pageId);
                }}
                onMaskIdChange={(mask) => {
                    setMaskId(mask);
                    onMaskIdChange(mask);
                }}
                navigationOpen={navigationOpen}
                setNavigationOpen={setNavigationOpen}
            />
    </SentryWrap>
    )
}

const mapStateToProps = state => ({
    currentUser: state.currentUser,
    booksAllList: state.booksAllList,
    activities: state.activities,
    quizzes: state.quizzes,
    interactions: state.interactions,
    tips: state.tipsBook
});

export default connect(mapStateToProps, null)(Index);